import { NgClass } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';

@Component({
  selector: 'joii-stepper',
  imports: [NgClass],
  templateUrl: './stepper.component.html',
  styleUrl: './stepper.component.css',
})
export class StepperComponent {
  stepCount = input<number>(0);
  currentStep = input<number>(0);
  onStepClick = output<number>();

  getSteps = computed(() => Array.from({ length: this.stepCount() }, (_, i) => i));
}
